import { useDetailTabContext } from '@/pages/User/pages/Home/components/DetailTab'

import { resolveHistoryPreviewVersion } from './previewHistoryUtils'

export const useHistoryPreviewVersion = () => {
	const {
		state: { version },
	} = useDetailTabContext()

	return resolveHistoryPreviewVersion(version)
}
